import {BACKEND_API} from '../middleware/backend'

export const PARTIES_REQUEST = 'PARTIES_REQUEST';
export const PARTIES_SUCCESS = 'PARTIES_SUCCESS';
export const PARTIES_FAILURE = 'PARTIES_FAILURE';
export const PARTIES_COUNT_REQUEST = 'PARTIES_COUNT_REQUEST';
export const PARTIES_COUNT_SUCCESS = 'PARTIES_COUNT_SUCCESS';
export const PARTIES_COUNT_FAILURE = 'PARTIES_COUNT_FAILURE';
export const PARTY_REQUEST = 'PARTY_REQUEST';
export const PARTY_SUCCESS = 'PARTY_SUCCESS';
export const PARTY_FAILURE = 'PARTY_FAILURE';
export const PARTIES_FIND_REQUEST = 'PARTIES_FIND_REQUEST';
export const PARTIES_FIND_SUCCESS = 'PARTIES_FIND_SUCCESS';
export const PARTIES_FIND_FAILURE = 'PARTIES_FIND_FAILURE';
export const PARTY_SAVE_REQUEST = 'PARTY_SAVE_REQUEST';
export const PARTY_SAVE_SUCCESS = 'PARTY_SAVE_SUCCESS';
export const PARTY_SAVE_FAILURE = 'PARTY_SAVE_FAILURE';
export const PARTY_DELETE_REQUEST = 'PARTY_DELETE_REQUEST';
export const PARTY_DELETE_SUCCESS = 'PARTY_DELETE_SUCCESS';
export const PARTY_DELETE_FAILURE = 'PARTY_DELETE_FAILURE';

export const loadParties = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [PARTIES_REQUEST, PARTIES_SUCCESS, PARTIES_FAILURE],
			endpoint: `party/list`,
			filter: filter
		}
	})
};

export const countParties = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [PARTIES_COUNT_REQUEST, PARTIES_COUNT_SUCCESS, PARTIES_COUNT_FAILURE],
			endpoint: `party/count`,
			filter: filter
		}
	})
};

export const loadParty = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [PARTY_REQUEST, PARTY_SUCCESS, PARTY_FAILURE],
			endpoint: `party/${id}`,
		}
	})
};

export const findParties = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [PARTIES_FIND_REQUEST, PARTIES_FIND_SUCCESS, PARTIES_FIND_FAILURE],
			endpoint: "party/find",
			filter: filter
		}
	})
};

export const saveParty = (party) => (dispatch, getState) => {

	return dispatch({
		party: party,
		[BACKEND_API]: {
			types: [PARTY_SAVE_REQUEST, PARTY_SAVE_SUCCESS, PARTY_SAVE_FAILURE],
			endpoint: party && party.partyId ? `party/${party.partyId}` : 'party',
			body: party
		}
	})
};

export const deleteParty = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [PARTY_DELETE_REQUEST, PARTY_DELETE_SUCCESS, PARTY_DELETE_FAILURE],
			endpoint: `party/${id}`,
			method: 'DELETE'
		}
	})
};
